import React, { useEffect, useState, useContext } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Link, useNavigate, NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "./Login.scss";
import { useMediaQuery, useTheme } from "@mui/material";
import lightlogo from "../../Img/reglogo.png";
import lgleft from "../../Img/lgleft.png";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
// import TextField from '@mui/material/TextField';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from "@mui/material/Modal";
import usercalls from "../../Axios";
import consts from "../../constant";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import signin from "../../Img/ph-img-signin.svg";
import LoginBtn from "./LoginBtn";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NativeSelect from "@mui/material/NativeSelect";
import AuthHeader from "./AuthHeader";
import AuthLeft from "./AuthLeft";
import Loader from "../Loader";
// import Checkbox from '@mui/material/Checkbox';
import newloginLogo from "../../Img/light-mode-logo.png";
// import newloginLogoLight from '../../Img/tx-light.png'

import { ThemeContext } from "../DarkMode/ThemeProvider";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--clr-bcg)",
  // border: '2px solid #000',
  boxShadow: " rgba(255, 255, 255, 0.24) 0px 3px 8px;",
  borderRadius: "10px",
  outline: "none",
  "@media(max-width:767.98px)": {
    width: "75%",
  },
  p: 4,
};

const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function SignInSide() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const path = usercalls();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [country, setCountry] = useState();
  const [phone, setPhone] = useState();
  const [load, setLoad] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [isOpen, setIsOpen] = useState(false);
  const toggleVisibility = () => {
    setIsOpen((prev) => !prev);
  };

  const { isLightMode, handleDarkmode } = useContext(ThemeContext);

  const countries = [
    "Select Country",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo (Congo-Brazzaville)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czechia (Czech Republic)",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini (fmr. Swaziland)",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (formerly Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia (formerly Macedonia)",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine State",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  const [phoneNumber, setPhoneNumber] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    // console.log(value, "value");
    // Allow only numbers
    if (/^\d*$/.test(value)) {
      setPhoneNumber(value);
    }
  };

  // console.log(md, 'md');

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleClickConfirmShowPassword = () =>
    setShowConfirmPassword((show) => !show);

  const [confPassErr, setConfPassErr] = useState("");

  const checkconfirmpass = (e) => {
    if (password != e) {
      setConfPassErr("Password Mismatching");
    } else {
      setConfPassErr("");
    }
  };

  // Regular expressions for validation
  const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/;
  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(\.[a-z]{2,8})?$/;
  const [referralCode, setReferralCode] = useState("");
  const [checked, setChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
    // console.log(event.target.checked);
  };

  // Submit handler
  const handleSubmit = async () => {
    try {
      setLoad(true);
      if (!nameCheck) {
        toast.error("name is required");
        return;
      }

      if (!country) {
        toast.error("Please select your country");
        return;
      }

      if (!phoneNumber) {
        toast.error("Please enter your phone number");
        return;
      }
      if (!email) {
        toast.error("Email is required");
        return;
      } else if (!emailRegex.test(email)) {
        toast.error("Invalid Email Format");
        return;
      }

      if (!password) {
        toast.error("Password is required");
        return;
      } else if (!passwordRegex.test(password)) {
        toast.error(
          "Password must contain at least 8 characters, one uppercase letter, one number, and one special character (e.g., Abc@1234)"
        );
        return;
      }
      if (confirmPassword === undefined) {
        toast.error("Please re-enter the password");
        return;
      } else if (confirmPassword !== password) {
        setConfPassErr("Passwords do not match");
        return;
      }

      if (!checked) {
        toast.error("Please accept the terms and conditions");
        return;
      }

      setLoad(true);

      const url = `${consts.BackendUrl}/register`;
      const payload = {
        email,
        password,
        name: nameCheck,
        country,
        phone: phoneNumber,
        referal: referralCode || "",
      };

      // console.log("Payload:", payload);

      const response = await path.postCallWithoutAuthToken({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setLoad(false);
        localStorage.setItem("email", email);
        handleOpen();

        const timer = setTimeout(() => {
          navigate("/verify")
        }, 15000);
        return () => clearTimeout(timer)
      } else {
        setLoad(false);
        toast.error(result.message || "Registration failed");
      }
    } catch (error) {
      setLoad(false);
      console.error("Error during registration:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  useEffect(() => {
    // console.log(
    //   window.localStorage.getItem("email"),
    //   "window.localStorage.getItem('email')"
    // );
    if (window.localStorage.getItem("email")) {
      setEmail(localStorage.getItem("email"));
      localStorage.removeItem("email");
    }
  }, []);

  const [nameCheck, setNameCheck] = useState("");
  const handleNameCheck = (event) => {
    setNameCheck(event.target.value);
  };

  const handleCountryChange = (event) => {
    const selectedValue = event.target.value;
    setCountry(selectedValue);
    // console.log(selectedValue, "selected country");
  };

  return (
    <>
      {/* <AuthHeader /> */}

      <ToastContainer />
      <div className="register">
        {load && <Loader />}
        <Grid
          container
          component="main"
          spacing={2}
          sx={{ alignItems: "center", pt: 0, height: !lg && "100vh" }}
          className={!md ? "medium" : ""}
        >
          {lg && (
            <Grid item xs={12} sm={12} md={6} lg={5.5} sx={{ pl: "13px" }}>
              <AuthLeft />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={6.5}>
            <Grid
              container
              sx={{ justifyContent: "center", alignItems: "end" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box
                  sx={{
                    my: md && 3,
                    mx: md && 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    // padding: "28px 25px",
                    maxWidth: "700px",
                    margin: "0 auto",
                    padding: "10px",
                  }}
                // className={!md && "log-bcg"}
                >
                  <div style={{ marginTop: '20px' }}>
                    <Typography component="h1" variant="h4" className="c-accout" sx={{ marginTop: '' }}>
                      Sign Up to Dreamster-Exchange
                    </Typography>
                    <LoginBtn />

                    <Box
                      // component="form" noValidate
                      // onSubmit={handleSubmit}
                      className="register-right"
                      sx={md ? { height: "79vh" } : { height: "100%" }}
                    >
                      <div className="email-fill">
                        <div className="email-name">
                          Name (as per government id){" "}
                          <span className="required"> * </span>
                        </div>
                        <TextField
                          className="inputtext-box"
                          margin="normal"
                          required
                          fullWidth
                          id="username"
                          placeholder="Enter name"
                          name="name"
                          autoComplete="name"
                          autoFocus
                          // helperText={nameCheck == " " || nameCheck.length <= 3 ? "Incorrect entry." : ''}
                          onChange={(e) => {
                            handleNameCheck(e);
                          }}
                          value={nameCheck}
                        />
                      </div>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={6}>
                          <div
                            className="email-fill"
                            style={{ marginTop: "8px" }}
                          >
                            <div className="email-name">
                              Country <span className="required"> * </span>
                            </div>
                            <FormControl className="inputtext-box select-country">
                              <NativeSelect
                                // defaultValue={countries[0]}
                                value={country} // Set the value to the state
                                onChange={handleCountryChange}
                                inputProps={{
                                  name: "country",
                                  id: "uncontrolled-native",
                                }}
                                className="inputtext-box"
                                style={{ borderBottom: "none" }}
                                margin="normal"
                                required
                                fullWidth
                              >
                                {countries.map((country, index) => (
                                  <option
                                    key={index}
                                    value={index === 0 ? "" : country}
                                  >
                                    {country}
                                  </option>
                                ))}
                              </NativeSelect>
                            </FormControl>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6}>
                          <div
                            className="email-fill"
                            style={{ marginTop: "8px" }}
                          >
                            <div className="email-name">
                              Phone <span className="required"> * </span>
                            </div>
                            <TextField
                              className="inputtext-box"
                              margin="normal"
                              required
                              fullWidth
                              id="phonenumber"
                              name="phone"
                              type="number"
                              autoComplete="phone"
                              autoFocus
                              placeholder="Enter your mobile number"
                              value={phoneNumber}
                              onChange={handleInputChange}
                              inputProps={{
                                maxLength: 10, // Optional: Limit the length to 10 digits
                              }}
                            />
                          </div>
                        </Grid>{" "}
                      </Grid>
                      <div className="email-fill">
                        <div className="email-name" style={{ marginTop: "8px" }}>
                          Email<span className="required"> * </span>
                        </div>
                        <TextField
                          className="inputtext-box"
                          margin="normal"
                          required
                          fullWidth
                          id="email"
                          placeholder="Enter your email address"
                          name="email"
                          autoComplete="email"
                          autoFocus
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />
                      </div>

                      <div className="email-fill " style={{ marginTop: "8px" }}>
                        <div className="email-name">Password</div>
                        <FormControl
                          sx={{ mt: 1, width: "100%" }}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? "text" : "password"}
                            value={password}
                            placeholder="Enter your password"
                            onChange={(e) => {
                              setPassword(e.target.value);
                            }}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label={
                                    showPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickShowPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </div>
                      <div
                        className="email-fill mt-10"
                        sx={{ marginTop: "10px" }}
                      >
                        <div className="email-name">
                          Re-Enter Password<span className="required"> * </span>
                        </div>
                        <FormControl
                          sx={{ mt: 1, width: "100%" }}
                          variant="outlined"
                        >
                          {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showConfirmPassword ? "text" : "password"}
                            value={confirmPassword}
                            onChange={(e) => {
                              checkconfirmpass(e.target.value);
                              setConfirmPassword(e.target.value);
                            }}
                            placeholder="Please re-enter your password"
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label={
                                    showConfirmPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickConfirmShowPassword}
                                  edge="end"
                                >
                                  {showConfirmPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>

                        {confPassErr != "" && (
                          <div
                            style={{
                              color: "red",
                              textAlign: "left",
                              marginTop: "5px",
                            }}
                          >
                            {confPassErr}
                          </div>
                        )}
                        <div
                          className="email-name"
                          onClick={toggleVisibility}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: "10px",
                            marginTop: "8px",
                            alignItems: "center",
                            borderRadius: "5px",
                          }}
                        >
                          {" "}
                          Referral Id (or) Voucher Code (optional){" "}
                          <span
                            style={{
                              transform: isOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.2s",
                            }}
                          >
                            <KeyboardArrowDownIcon />
                          </span>
                        </div>

                        {isOpen && (
                          <TextField
                            className="inputtext-box"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            placeholder="referral code"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            value={referralCode}
                            onChange={(e) => {
                              setReferralCode(e.target.value);
                            }}
                          />
                        )}
                      </div>

                      <div className="reg-forget term-condition mt-10 display-2">
                        <div>
                          {" "}
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checked}
                                onChange={handleCheckboxChange}
                                value="remember"
                                color="primary"
                              />
                            }
                            label="I accept the "
                            sx={{ marginLeft: "0 !important" }}
                          />
                          <Link href="#" variant="body2">
                            Terms Of Use
                          </Link>
                        </div>
                        <div className="recieve-mail cursor">
                          {" "}
                          Did not receive{" "}
                          <Link to="/resend" variant="body2">
                            activation mail ?
                          </Link>
                        </div>
                      </div>
                      {/* <Button class="button">
  Apply Now
  <svg fill="currentColor" viewBox="0 0 24 24" class="icon">
    <path
      clipRule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
      fillRule="evenodd"
    ></path>
  </svg>
</Button> */}
                      <div className="mt-10 common-btn">
                        {load ? (
                          <Button
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                          >
                            Processing...
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            // onClick={(() => { navigate('/register-success') })}
                            onClick={() => {
                              handleSubmit();
                            }}
                          >
                            Register
                          </Button>
                        )}
                      </div>
                      {/* <div className="conti mt-10">
                                            <Button
                                                type="submit"
                                                fullWidth
                                                variant="contained"
                                                sx={{ mt: 3, mb: 2 }}
                                            onClick={(() => { navigate('/register-success') })}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_79_124)">
                                                        <path d="M19.8052 10.2303C19.8052 9.55056 19.7501 8.86711 19.6325 8.19836H10.2002V12.0492H15.6016C15.3775 13.2911 14.6573 14.3898 13.6027 15.0879V17.5866H16.8252C18.7176 15.8449 19.8052 13.2728 19.8052 10.2303Z" fill="#0177FE" />
                                                        <path d="M10.1999 20.0006C12.897 20.0006 15.1714 19.1151 16.8286 17.5865L13.6061 15.0879C12.7096 15.6979 11.5521 16.0433 10.2036 16.0433C7.59474 16.0433 5.38272 14.2832 4.58904 11.9169H1.26367V14.4927C2.96127 17.8695 6.41892 20.0006 10.1999 20.0006Z" fill="#34A853" />
                                                        <path d="M4.58564 11.9169C4.16676 10.675 4.16676 9.33014 4.58564 8.08818V5.51239H1.26395C-0.154389 8.33804 -0.154389 11.6671 1.26395 14.4927L4.58564 11.9169Z" fill="#FBBC04" />
                                                        <path d="M10.1999 3.95805C11.6256 3.936 13.0035 4.47247 14.036 5.45722L16.8911 2.60218C15.0833 0.904587 12.6838 -0.0287217 10.1999 0.000673888C6.41892 0.000673888 2.96126 2.13185 1.26367 5.51234L4.58537 8.08813C5.37537 5.71811 7.59106 3.95805 10.1999 3.95805Z" fill="#EA4335" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_79_124">
                                                            <rect width="20" height="20" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>

                                                Continue with Google
                                            </Button>
                                        </div> */}

                      <div className="text-center alraedy mt-10">
                        <Link to="/login" variant="body2">
                          {"Already have an account? "}
                          <span>Login</span>
                        </Link>
                      </div>

                      {/* <Copyright sx={{ mt: 5 }} /> */}
                    </Box>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Modal
            open={open}
            // onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="text-right">
                {/* <HighlightOffIcon onClick={handleClose} /> */}
              </div>
              <div className="text-center">
                <img src={newloginLogo} alt="newloginLogo" width={200} />
              </div>
              <div className="c-accout text-center mt-20">
                Registered Successfully
              </div>
              <div className="alraedy mt-20">
                Thankyou for registering with us.
              </div>
              <div className="alraedy mt-10">Kindly Verify your email</div>

              <div className="regbtn mt-10 display-3">
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  onClick={() => {
                    navigate("/verify");
                  }}
                >
                  Verify
                </Button>
              </div>
            </Box>
          </Modal>
        </Grid>
      </div>
    </>
  );
}
